import { Mark, mergeAttributes } from '@tiptap/core';

export interface AIHighlightOptions {
  HTMLAttributes: Record<string, string>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    AIHighlight: {
      setAIHighlight: (attributes?: { color: string }) => ReturnType;
      unsetAIHighlight: () => ReturnType;
    };
  }
}

export const AIHighlight = Mark.create<AIHighlightOptions>({
  name: 'ai-highlight',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-color') || element.style.backgroundColor,
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {};
          }

          return {
            'data-color': attributes.color,
            style: `background-color: ${attributes.color}; color: inherit`,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'mark[data-ai-highlight]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'mark',
      mergeAttributes(this.options.HTMLAttributes, { 'data-ai-highlight': '' }, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setAIHighlight:
        (attributes) =>
        ({ commands }) => {
          return commands.setMark(this.name, attributes);
        },
      unsetAIHighlight:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});

const AI_HIGHLIGHT_MARK_REGEX = /<mark[^>]*data-ai-highlight[^>]*>([\s\S]*?)<\/mark>/g;

/** Remove ephemeral selection highlight marks from HTML before AI or persistence. */
export function stripAiHighlightMarks(html: string): string {
  return html.replace(AI_HIGHLIGHT_MARK_REGEX, '$1');
}
